import { Component } from 'react';
import {Link} from 'react-router-dom'
import withAuth from '../../components/withAuth';
import {withStyles} from '@mui/styles';
import PropTypes from 'prop-types';
import {compose} from "redux";
import {connect} from "react-redux";
import AbsenceContent from "./AbsenceContent";
import AbsencesFilters from '../../components/Absences/AbsencesFilters'
import Fab from "@mui/material/Fab";
import Icon from "@mui/material/Icon/Icon";
import FooterFixedOnScreen from '../Layout/FooterFixedOnScreen'
import { redirect, getAbsencesActivityTypes, setEditionState, resetAbsenceSelection
} from "../../redux/absences/absencesActions";
import '../../utils.css';
import '../Layout/SubHeader.css';
import "./Absence.css";

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing(3),
        overflowX: 'auto',
    },
    bar: {
        backgroundColor: '#F5F6F5',
    },
    table: {
        minWidth: 700,
    },
    row: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.background.default,
        },
    },
});

class Absence extends Component {

    constructor(props){
        super(props);
        this.props.resetRedirect();
        this.props.resetAbsenceSelection(this.props.activeUser.emp_id, this.props.activeUser.id);
        this.props.getAbsencesActivityTypes(this.props.absences.absenceCreationFields, this.props.absenceDetails, this.props.activeUser);
    }

    onCreateClick(){
        this.props.setEditionState(true, false , false);
    }

    render() {
        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding main-div">
                <div className="col-lg-12 col-md-12 col-sm-12 col-12 absence without-side-padding">
                    <AbsencesFilters classes={this.props.classes}/>
                    <AbsenceContent />
                </div>
                <FooterFixedOnScreen>
                    <div className="offset-lg-9 col-lg-3 offset-md-8 col-md-4 offset-sm-6 col-sm-6 offset-6 col-6">
                        <Fab color="primary" component={Link} className="div-center"
                            to="/absences/createAbsence" onClick={this.onCreateClick.bind(this)}>
                            <Icon>add</Icon>
                        </Fab>
                        <span className="floating-btn-text span-center">Créer</span>
                    </div>
                </FooterFixedOnScreen>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        activeUser: state.activeUser,
        absences: state.absences,
        absenceDetails: state.absences.absenceDetails,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getAbsencesActivityTypes: (absenceCreationFields, details, activeUser) => dispatch(getAbsencesActivityTypes(absenceCreationFields, details, activeUser)),
        resetRedirect: () => dispatch(redirect(null)),
        setEditionState: (creationMode, updateMode, validationMode) => dispatch(setEditionState(creationMode, updateMode, validationMode)),
        resetAbsenceSelection: (empId, userId) => dispatch(resetAbsenceSelection(empId, userId)),
    };
};

Absence.propTypes = {
    classes: PropTypes.object.isRequired
};

export default compose(withAuth, withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(Absence);
